import React, { useState, useRef, useEffect } from "react";
import close from "../../assets/svg/close.svg";
import upload from "../../assets/svg/upload.svg";
import img from "../../assets/svg/img.svg";
import { Container, Row, Col } from "react-bootstrap";
import SearchWithAPI from "../searchbox/searchbox.js";
import "./dock.css";
import DOMPurify from "dompurify";
import SearchWithFreeTextAPI from "../searchbox/searchbox-free-text.js";
import { createDockApi, getDefaultGateApi, getDockDelayApi, getEnabledFieldApi, getVehicleScanDataApi, uploadDockAttachmentApi } from "./dock-api.js";
import takePhoto from "../../assets/svg/camera-add.svg";
import CapturePictureModal from "../common/capture-picture.js";
import ScanQRCodeModal from "../common/scan-qr-code.js";
import scan from "../../assets/svg/scan.svg";
// Reusable Input Component
const LabeledInput = ({ label, ...props }) => (
  <div style={{ flex: 1, marginBottom: "15px" }}>
    <label
      style={{
        fontSize: "13px",
        fontFamily: "epilogue",
        fontWeight: "400",
        marginBottom: "5px",
        display: "block",
      }}>
      {label}
    </label>
    <input
      {...props}
      style={{
        width: "100%",
        height: "44px",
        padding: "10px 16px 10px 16px",
        borderRadius: "12px",
        border: "1px solid #E5E5E5",
        fontSize: "13px",
        fontFamily: "epilogue",
        fontWeight: "400",
        ...props.style,
      }}
    />
  </div>
);

const modalStyle = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    opacity: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#ffffff",
    padding: "16px 24px",
    borderRadius: "16px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0)",
    width: "365px",
    height: "474px",
    textAlign: "center",
  },
};

// Reusable Select Component
const LabeledSelect = ({ label, options, ...props }) => (
  <div style={{ flex: 1, marginBottom: "15px" }}>
    <label
      style={{
        fontSize: "13px",
        fontFamily: "epilogue",
        fontWeight: "400",
        marginBottom: "5px",
        display: "block",
      }}>
      {label}
    </label>
    <select
      {...props}
      style={{
        width: "100%",
        height: "44px",
        padding: "10px 16px 10px 16px",
        borderRadius: "8px",
        border: "1px solid #E5E5E5",
        fontSize: "13px",
        fontFamily: "epilogue",
        fontWeight: "400",
      }}>
      <option>Select</option>
      {options?.map((opt, index) => (
        <option key={index} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

export default function AddDockForm({ scanDataResult, onSuccess, onClose }) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const [validations, setValidations] = useState({
    driver_name: "",
    dock_id: "",
    dock_type: "",
    vehicletype_id: "",
    vehicle_number: "",
    department_id: "",
    product_type_id: "",
    customer_id: "",
    vendor_id: "",
    attachment: "",
  });
  const [isOpenScan, setIsOpenScan] = useState(false);
  const [vehicleNumber, setVehicleNumber] = useState(null);
  const [driverName, setDriverName] = useState(null);
  const [dockNumberOption, setDockNumberOption] = useState(null);
  const [vendorOption, setVendorOption] = useState(null);
  const [customerOption, setCustomerOption] = useState(null);
  const [departmentOption, setDepartmentOption] = useState(null);
  const [productTypeOption, setProductTypeOption] = useState(null);
  const [dockType, setDockType] = useState("load_in");
  const [dockTypeOptions, setDockTypeOptions] = useState([
    { label: "Loading", value: "load_in" },
    { label: "Unloading", value: "load_out" },
  ]);
  const [vehicleTypeOption, setVehicleTypeOption] = useState(null);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [delayReasonOption, setDelayReasonOption] = useState(null);
  const [isDelayReasonRequired, setIsDelayReasonRequired] = useState(null);

  useEffect(() => {
    getEnabledField();
  }, []);

  useEffect(() => {
    if (scanDataResult != null) {
      setVehicleNumber(scanDataResult.vehicle_number);
      setDriverName(scanDataResult.driver_name);
      setVehicleTypeOption({ value: scanDataResult.vehicletype_id, label: scanDataResult.vehicle_type });
      setDepartmentOption({ value: scanDataResult?.department_id ?? "", label: scanDataResult?.department ?? "" });
      getDockStatus(scanDataResult.id);
      
    }
  }, [scanDataResult]);

  const [enabledFields, setEnabledFields] = useState([]);
  const [mandatoryFields, setMandatoryFields] = useState([]);
  useEffect(() => {
    
    getEnabledField();
  }, [departmentOption]);

  const getEnabledField = async () => {
    const data = {
      department_id: departmentOption != null ? departmentOption.value : "",
      dock_id: /*  dockNumberOption != null ? dockNumberOption.value : */ "",
    };
    try {
      const response = await getEnabledFieldApi(data);
      if (response.success === true) {
        setEnabledFields(response?.enabled_fields ?? {});
        setMandatoryFields(response?.mandatory_fields ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const isFieldEnabled = (field) => {
    return enabledFields.some((item) => item === field);
  };
  const isFieldMandatory = (field) => {
    return mandatoryFields.some((item) => item === field);
  };

  const handleVehicleDropdownChange = (option) => {
    console.log(option);
    setVehicleNumber(option.label);
    validateVehicleScanData(option.transaction_id);
    getDockStatus(option.value);
  };
  const validateVehicleScanData = async (qrTag) => {
    try {
      const response = await getVehicleScanDataApi(qrTag);
      console.log(response.data);
      if (response.data.success === true) {
        setDriverName(response.data.data?.driver_name ?? "");
        setVehicleTypeOption({ value: response.data?.data?.vehicletype_id ?? "", label: response.data?.data?.vehicle_type ?? "" });
        setDepartmentOption({ value: response.data?.data?.department_id ?? "", label: response.data?.data?.department ?? "" });
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getDockStatus = async (vehId) => {
    const response = await getDockDelayApi(vehId);
    if (response.status === 200) {
      if (response.data.success === true) {
        if (response.data.field !== null && response.data.field === "Dock In Delay reason") {
          setIsDelayReasonRequired(true);
        }
      }
    }
  };
  const handleVehicleOnChange = (term) => {
    setVehicleNumber(term);
  };

  const handleDriverNameDropdownChange = (option) => {
    setDriverName(option.label);
  };
  const handleDriverNameOnChange = (term) => {
    setDriverName(term);
  };

  const handleDockNumberDropdownChange = (option) => {
    console.log(option);
    setDockNumberOption(option);
  };

  const handleVendorChange = (option) => {
    console.log(option);
    setVendorOption(option);
  };

  const handleCustomerChange = (option) => {
    console.log(option);
    setCustomerOption(option);
  };
  const handleDepartmentChange = (option) => {
    console.log(option);
    setDepartmentOption(option);
  };

  const handleProductTypeChange = (option) => {
    console.log(option);
    setProductTypeOption(option);
  };

  const handleVehicleTypeDropdownChange = (option) => {
    console.log(option);
    setVehicleTypeOption(option);
  };
    const handleReasonDropdownChange = (option) => {
    console.log(option);
    setDelayReasonOption(option);
  };

  useEffect(() => {
    getDefaultGate();
  }, [departmentOption, productTypeOption, customerOption, vendorOption, vehicleTypeOption]);

  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const [base64FileList, setBase64FileList] = useState([]);
  const [urlImageList, setUrlImageList] = useState([]);
  const [removedImageList, setRemovedImageList] = useState([]);

  const handleFileChange = (event) => {
    if (base64FileList.length + urlImageList.length >= 5) {
      setValidations((prev) => ({ ...prev, attachment: "Maximum 5 images only allowed." }));
      return;
    }
    setValidations((prev) => ({ ...prev, attachment: "" }));
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        const tempBase64FileList = [...base64FileList];
        tempBase64FileList.push(base64String);
        setBase64FileList(tempBase64FileList);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid image file.");
    }
  };
  const submitDock = async () => {
    const dataBeforeSanitize = {
      driver_name: driverName != null ? driverName : "",
      dock_id: dockNumberOption != null ? dockNumberOption.value : "",
      dock_type: dockType,
      vehicletype_id: vehicleTypeOption != null ? vehicleTypeOption.value : "",
      vehicle_number: vehicleNumber,
      department_id: departmentOption != null ? departmentOption.value : "",
      product_type_id: productTypeOption != null ? productTypeOption.value : "",
      customer_id: customerOption != null ? customerOption.value : "",
      vendor_id: vendorOption != null ? vendorOption.value : "",
      attachment: base64FileList.length,
      reason: delayReasonOption!= null ? delayReasonOption.value : "",
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });

    const response = await createDockApi(dataAfterSanitize);
    if (response.status === 200) {
      if (response.data.success === true) {
        if (base64FileList.length > 0) {
          uploadAttachment(response.data.id);
        }
        onSuccess(response.data);
      }
    }
    if (response.status === 400) {
      new Promise((resolve, reject) => {
        const validationTemp = {
          driver_name: "",
          dock_id: "",
          dock_type: "",
          vehicletype_id: "",
          vehicle_number: "",
          department_id: "",
          product_type_id: "",
          customer_id: "",
          vendor_id: "",
          attachment: "",
        };
        Object.entries(response.data.error).forEach(([key, value]) => {
          console.log(`${key}: ${value}`);
          validationTemp[key] = value.length === 0 ? "" : value[0];
        });
        console.log("validationTemp...", validationTemp);
        setValidations(validationTemp);
      });
    }
  };

  const uploadAttachment = async (id) => {
    const response = await uploadDockAttachmentApi({ id: id, type: "in", attachments: base64FileList });
    if (response.status === 200) {
    }
  };
  const onSuccessCapture = async (captureImage) => {
    if (base64FileList.length + urlImageList.length >= 5) {
      setValidations((prev) => ({ ...prev, attachment: "Maximum 5 images only allowed." }));
      setIsCameraOpen(false);
      return;
    }
    setValidations((prev) => ({ ...prev, attachment: "" }));
    const tempBase64FileList = [...base64FileList];
    tempBase64FileList.push(captureImage);
    setBase64FileList(tempBase64FileList);
    setIsCameraOpen(false);
  };
  const dockScanDataResult = async (result) => {
    setDockNumberOption({ value: result.id, label: result.name });
    setIsOpenScan(false);
  };
  const getDefaultGate = async () => {
    try {
      const response = await getDefaultGateApi({ department_id: departmentOption?.value ?? "", product_type_id: productTypeOption?.value ?? "", customer_id: customerOption?.value ?? "", vendor_id: vendorOption?.value ?? "", vehicle_id: vehicleTypeOption?.value ?? "" });
      console.log(response.data);
      if (response.data.success === true) {
        if (response.data.data != null) {
          setDockNumberOption({ value: response.data.data.value, label: response.data.data.label });
        } else {
          setDockNumberOption(null);
        }
      } else {
        setDockNumberOption(null);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  return (
    <div
      style={{
        maxWidth: "100%",
        margin: "0 auto",
        /* padding: "20px", */
        fontFamily: "epilogue",
        position: "relative",
        borderRadius: "12px",
      }}>
      {isOpenScan && (
        <ScanQRCodeModal
          scanDataResult={dockScanDataResult}
          onCancel={() => {
            setIsOpenScan(false);
          }}
        />
      )}
      {isCameraOpen && (
        <CapturePictureModal
          onSuccess={onSuccessCapture}
          onCancel={() => {
            setIsCameraOpen(false);
          }}
        />
      )}
      {/* Header */}
      <div
        style={{
          borderBottom: "1px solid #D4DDE7",
          paddingBottom: "12px",
          marginBottom: "12px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "8px",
        }}>
        <div>
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "700",
              margin: 0,
              color: "#212129",
            }}>
            Add dock
          </h2>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "400",
              marginTop: "10px",
              color: "#212129",
            }}>
            Enter below details to create new dock
          </div>
        </div>
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "1px solid #D4DDE7",
            borderRadius: "100px",
            padding: "8px",
            height: "40px",
            width: "40px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <img src={close} alt="close" style={{ width: "14px", height: "14px" }} />
        </button>
      </div>

      <Row className="px-0 mx-0">
        {isFieldEnabled("Vehicle") && (
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 pe-md-1">
            <div className="field-title mb-1">Vehicle{isFieldMandatory("Vehicle") && <span style={{ color: "#FF4444" }}>*</span>}</div>
            <SearchWithFreeTextAPI onDropdownChange={handleVehicleDropdownChange} onChangeSearch={handleVehicleOnChange} apiUrl={apiUrl + `get_queue_vehicle?term=`} params={{}} searchLimit={0} placeholder={"Vehicle Number"} selectedValue={vehicleNumber} />
            {/*  <SearchWithAPI onDropdownChange={handleVehicleDropdownChange} apiUrl={apiUrl + "get_queue_vehicle?term="} params={{}} placeholder={"Select"} selectedOption={vehicleNumber} /> */}
            <span className="field-error">{validations.vehicle_number}</span>
          </Col>
        )}
        {isFieldEnabled("Driver Name") && (
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ">
            <div className="field-title mb-1">Driver Name{isFieldMandatory("Driver Name") && <span style={{ color: "#FF4444" }}>*</span>}</div>
            <SearchWithFreeTextAPI onDropdownChange={handleDriverNameDropdownChange} onChangeSearch={handleDriverNameOnChange} apiUrl={apiUrl + `dock/driver?term=`} params={{}} searchLimit={0} placeholder={"Driver Name"} selectedValue={driverName} />
            {/* <SearchWithAPI onDropdownChange={handleDriverNameDropdownChange} apiUrl={apiUrl + "dock/driver"} params={{}} placeholder={"Select"} selectedOption={driverName} /> */}
            <span className="field-error">{validations.driver_name}</span>
          </Col>
        )}
        {isFieldEnabled("Vehicle Type") && (
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">Vehicle Type{isFieldMandatory("Vehicle Type") && <span style={{ color: "#FF4444" }}>*</span>}</div>
            <SearchWithAPI onDropdownChange={handleVehicleTypeDropdownChange} apiUrl={apiUrl + "vehicletype/autosuggestion"} params={{}} placeholder={"Select"} selectedOption={vehicleTypeOption} />
            <span className="field-error">{validations.vehicletype_id}</span>
          </Col>
        )}
        {isFieldEnabled("Department") && (
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">Department{isFieldMandatory("Department") && <span style={{ color: "#FF4444" }}>*</span>}</div>
            <SearchWithAPI onDropdownChange={handleDepartmentChange} apiUrl={apiAdminUrl + "get_department"} params={{}} placeholder={"Select"} selectedOption={departmentOption} />
            <span className="field-error">{validations.department_id}</span>
          </Col>
        )}
        {isFieldEnabled("Dock Type") && (
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-2">Dock Type{isFieldMandatory("Dock Type") && <span style={{ color: "#FF4444" }}>*</span>}</div>
            <div className="style-justify-start" style={{ flexWrap: "wrap", gap: "8px" }}>
              {dockTypeOptions.map((type, index) => (
                <label className={`${dockType === type.value ? "dock-type-txt-active" : "dock-type-txt-inactive"}`}>
                  <input
                    type="radio"
                    name="options"
                    value={type.value}
                    checked={dockType === type.value}
                    onChange={(event) => {
                      setDockType(event.target.value);
                      if (event.target.value === "load_in") {
                        setCustomerOption(null);
                      } else {
                        setVendorOption(null);
                      }
                    }}
                    className="custom-radio"
                  />
                  <span className={`px-2 ${dockType === type.value ? "dock-type-txt-active" : "dock-type-txt-inactive"}`}>{type.label}</span>
                </label>
              ))}
            </div>
          </Col>
        )}
        {isFieldEnabled("Vendor") && dockType === "load_in" && (
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">Vendor{isFieldMandatory("Vendor") && <span style={{ color: "#FF4444" }}>*</span>}</div>
            <SearchWithAPI onDropdownChange={handleVendorChange} apiUrl={apiUrl + "get_vendor"} params={{}} placeholder={"Select"} selectedOption={vendorOption} />
            <span className="field-error">{validations.vendor_id}</span>
          </Col>
        )}

        {isFieldEnabled("Customer") && dockType === "load_out" && (
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">Customer{isFieldMandatory("Customer") && <span style={{ color: "#FF4444" }}>*</span>}</div>
            <SearchWithAPI onDropdownChange={handleCustomerChange} apiUrl={apiUrl + "get_customer"} params={{}} placeholder={"Select"} selectedOption={customerOption} />
            <span className="field-error">{validations.customer_id}</span>
          </Col>
        )}

        {isFieldEnabled("Product type") && (
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">Product Type{isFieldMandatory("Product type") && <span style={{ color: "#FF4444" }}>*</span>}</div>
            <SearchWithAPI onDropdownChange={handleProductTypeChange} apiUrl={apiUrl + "get_product_type"} params={{}} placeholder={"Select"} selectedOption={productTypeOption} />
            <span className="field-error">{validations.product_type_id}</span>
          </Col>
        )}

        {isFieldEnabled("Dock Number") && (
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">Dock Number{isFieldMandatory("Dock Number") && <span style={{ color: "#FF4444" }}>*</span>}</div>
            <div className="style-justify-start">
              <div style={{ flex: 1 }}>
                <SearchWithAPI onDropdownChange={handleDockNumberDropdownChange} apiUrl={apiUrl + "dockmaster/autosuggestion"} params={{type:'create'}} placeholder={"Select"} selectedOption={dockNumberOption} />
              </div>
              <button
                type="button"
                className="scan_btn ms-1 px-3"
                style={
                  {
                    /* width: "91px" */
                  }
                }
                onClick={() => {
                  setIsOpenScan(true);
                }}>
                <img src={scan} alt="scan" srcSet="" />
              </button>
            </div>
            <span className="field-error">{validations.dock_id}</span>
          </Col>
        )}
        {isDelayReasonRequired === true && (
          <Col xs={12} sm={12} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">Dock In Delay Reason{isFieldMandatory("Product type") && <span style={{ color: "#FF4444" }}>*</span>}</div>
             <SearchWithAPI onDropdownChange={handleReasonDropdownChange} apiUrl={apiUrl + "get_reasons?"} params={{type:'dock_in_delay'}} placeholder={"Select"} selectedOption={delayReasonOption} />
            {/* <textarea
              type="text"
              placeholder=" "
              className="input-field w-100"
              value={delayReason}
              onChange={(event) => {
                setDelayReason(event.target.value); // Update state with input value
              }}
            /> */}
            <span className="field-error">{validations.product_type_id}</span>
          </Col>
        )}
      </Row>

      <label
        className="mt-2"
        style={{
          fontSize: "13px",
          fontFamily: "epilogue",
          fontWeight: "400",
          marginBottom: "5px",
          display: "block",
        }}>
        Add any special requests
      </label>
      <span className="field-error">{validations.attachment}</span>
      <div
        style={{
          borderRadius: "12px",
          padding: "20px",
          textAlign: "center",
          marginBottom: "20px",
          backgroundColor: "#F9F9F9",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
        <img src={img} alt="Upload icon" style={{ width: "40px", marginBottom: "10px" }} />
        <div style={{ fontSize: "14px", fontWeight: 500, color: "#888" }}>Upload proof image</div>
        <div style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}>Maximum 5 images only</div>
        <div className="style-justify-center gap-2">
          <button
            onClick={handleFileClick}
            style={{
              marginTop: "10px",
              color: "#d33",
              border: "1px solid #E5E5E5",
              padding: "10px 16px 10px 16px",
              borderRadius: "37px",
              background: "#FFFFFF",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "13px",
              fontFamily: "epilogue",
              fontWeight: "500",
            }}>
            <img src={upload} alt="Upload icon" style={{ width: "16px", height: "16px" }} />
            Upload
          </button>
          <button
            onClick={() => {
              setIsCameraOpen(true);
            }}
            style={{
              marginTop: "10px",
              color: "#d33",
              border: "1px solid #E5E5E5",
              padding: "10px 16px 10px 16px",
              borderRadius: "37px",
              background: "#FFFFFF",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "13px",
              fontFamily: "epilogue",
              fontWeight: "500",
            }}>
            <img src={takePhoto} alt="Capture" style={{ width: "16px", height: "16px" }} />
            Take Photo
          </button>
        </div>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept=".jpg, .jpeg, .png"
        onChange={handleFileChange}
        style={{ display: "none" }} // Hide the actual file input
      />
      <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
        {urlImageList.map((urlImage, index) => (
          <div key={"url-image-" + index} className="mt-3" style={{ position: "relative" }}>
            <img src={urlImage != null && urlImage !== "" ? urlImage.image : ""} alt="complaint" style={{ width: "72px", height: "72px", borderRadius: "14px" }} />
            <div
              style={{
                position: "absolute",
                top: "1px",
                right: "1px",
              }}>
              <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                <img
                  src={close}
                  alt=""
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    const tempRemoved = [...removedImageList];
                    tempRemoved.push(urlImage.id);
                    removedImageList(tempRemoved);
                    const tempURLImageList = [...urlImageList];
                    tempURLImageList.splice(index, 1);
                    setUrlImageList(tempURLImageList);
                    if (tempURLImageList.length + base64FileList.length < 5) {
                      setValidations((prev) => ({ ...prev, attachment: "" }));
                    }
                  }}
                />
              </div>
            </div>
          </div>
        ))}
        {base64FileList.map((baseImage, index) => (
          <div key={"base-image-" + index} className="mt-3" style={{ position: "relative" }}>
            <img src={baseImage != null && baseImage !== "" ? baseImage : ""} alt="complaint" style={{ width: "72px", height: "72px", borderRadius: "14px" }} />
            <div
              style={{
                position: "absolute",
                top: "1px",
                right: "1px",
              }}>
              <div style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                <img
                  src={close}
                  alt=""
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    const tempImageList = [...base64FileList];
                    tempImageList.splice(index, 1);
                    setBase64FileList(tempImageList);
                    if (tempImageList.length + urlImageList.length < 5) {
                      setValidations((prev) => ({ ...prev, attachment: "" }));
                    }
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Action Buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px", // adds spacing between the buttons
        }}>
        <button
          style={{
            padding: "10px 20px",
            borderRadius: "20px",
            backgroundColor: "#ffff",
            border: "1px solid #E5E5E5",
            cursor: "pointer",
          }}
          onClick={onClose}>
          Cancel
        </button>
        <button
          onClick={submitDock}
          style={{
            padding: "10px 20px",
            borderRadius: "20px",
            border: "none",
            backgroundColor: "#D35258",
            color: "#fff",
            fontWeight: "bold",
            cursor: "pointer",
          }}>
          Save
        </button>
      </div>
    </div>
  );
}
